// Generated with tools/create-component.js
import React from "react";
import { CmsContent, Container, Icon, Image, Link } from "components";
import { BackgroundColourEnum, ContainerSpacingEnum, ContainerWidthEnum } from "utils";
import { RelatedPagesQueryFragment } from "codegen";
import "./RelatedPages.scss";

interface RelatedPagesProps {
  data: RelatedPagesQueryFragment;
}

export const RelatedPages: React.FC<RelatedPagesProps> = ({ data: { content, pages } }): JSX.Element => {
  return (
    <Container
      className="related-pages"
      // containerSpacing={ContainerSpacingEnum["SECTION_NONE"]}
      containerWidth={ContainerWidthEnum["LAYOUT_SMALL"]}
      // backgroundColour={BackgroundColourEnum["PRIMARY"]}
    >
      <div className="related-pages__intro">
        <CmsContent content={content} />
      </div>
      {pages &&
        Object.keys(pages).length > 0 &&
        pages?.map((page, index) => {
          return (
            <Link to={page?.link?.url} className="related-pages__card" key={index}>
              <div className="related-pages__card__content">
                <h3>{page?.link?.title}</h3>
                <Icon name="ArrowLink" size={4} color="--brand-secondary" />
              </div>
              <Image src={page?.image} />
            </Link>
          );
        })}
    </Container>
  );
};
